import { loadScript } from '@avensia/excite';
import { useOnScreen } from '@avensia/excite-ui';
import * as React from 'react';

declare global {
  interface Window {
    KlarnaOnsiteService: { eventName: string }[];
  }
}

async function loadKlarnaScript(
  klarnaOnSiteMessagesSettingsProvider: () => Promise<{ dataClientId: string; scriptUrl: string }>,
  isInViewport: boolean,
) {
  const settings = await klarnaOnSiteMessagesSettingsProvider();

  if (isInViewport && settings.scriptUrl) {
    loadScript(settings.scriptUrl, {
      async: true,
      attributes: { ['data-client-id']: settings.dataClientId },
    }).then(() => {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    });
  }
}

export function useKlarnaOnSiteMessaging(
  klarnaOnSiteMessagesSettingsProvider: () => Promise<{ dataClientId: string; scriptUrl: string }>,
) {
  const [isInViewport, ref] = useOnScreen<HTMLDivElement>('100px');
  React.useEffect(() => {
    loadKlarnaScript(klarnaOnSiteMessagesSettingsProvider, isInViewport);
  }, [klarnaOnSiteMessagesSettingsProvider, isInViewport]);

  return ref;
}
